exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-upload-type {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background: #fff;\n  padding: 0 20px 20px;\n  overflow-x: auto; }\n  .page-upload-type .upload-type-list {\n    padding: 25px; }\n  .page-upload-type .hidden {\n    display: none; }\n  .page-upload-type .type-button {\n    margin-left: -20px;\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    text-align: center;\n    color: #004475;\n    outline: none !important; }\n    .page-upload-type .type-button i {\n      font-size: 20px; }\n  .page-upload-type .type-image {\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: top;\n    height: 0;\n    width: 100%;\n    padding-bottom: 80%; }\n  .page-upload-type .button {\n    margin: 9px auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Upload/UploadType/styles.scss
// module id = 1323
// module chunks = 0